<template>
  <DashboardTemplate :navMenu="true" class="set-score">
  
    <div class="text-left pd-b-3">
      <h2 class="mg-less">ผลคะแนนการเรียนแต่ละหลักสูตร</h2>
    </div>
    <div v-if="courseList.length > 0">
      <div
        
        class="text-left pd-b-3 flex-display ai-center border-b custom-display"
      >
        <p class="mg-less">เลือกหลักสูตร</p>
        <el-dropdown class="mg-l-4" trigger="click">
          <span class="el-dropdown-link course-box">
            <span class="message-over clamp1">{{ course.name }}</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>

          <el-dropdown-menu slot="dropdown" class="course-box-menu">
            
            <el-dropdown-item v-for="item in courseList" :key="item._id">
              <div
                @click="course = item"
                class="dropdown-text-over"
                :title="item.name"
              >
                {{ item.name }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button
          type="primary"
          class="light mg-l-4"
          round
          @click="sendIdCourse()"
          >แสดงผล</el-button
        >
      </div>
      <div class="text-left pd-b-3 pd-t-3">
        <h3 class="mg-less">ผลคะแนนการเรียนแต่ละหลักสูตร</h3>
      </div>
      <div v-loading="loading" class="width-table">
        <ActivitySubjectDetailList
          :courseScoreList="courseScoreList"
          :courseId="courseId"
          :userId="user.userId"
          :subjectSuccess="subjectSuccess"
        />
      </div>
    </div>
    <div v-else>
      <p class="color-gray pd-t-1">*** ยังไม่มีหลักสูตรที่ลงทะเบียน ***</p>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import ActivitySubjectDetailList from "@/components/activity/ActivitySubjectDetailList";
import { HTTP } from "@/service/axios.js";
import {CancelToken } from "axios";


export default {
  components: {
    DashboardTemplate,
    ActivitySubjectDetailList,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    this.fetchMyCourse();
  
  },
  data() {
    return {
      course: "",
      courseId: "",
      loading: true,
      courseScoreList: null,
      courseList:[],
      subjectSuccess:false,
      source:''
    };
  },
  methods: {
    sendIdCourse() {
      this.loading = true;
      this.courseId = this.course._id;
      this.subjectSuccess = this.course.subject.length == this.course.subjectNumber
      this.fetchPercentSubjects();
    },
    fetchMyCourse() {
      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`my/course`)
        .then((res) => {
          if (res.data.success) {
            this.courseList = res.data.obj.studying.concat(res.data.obj.complete);
            this.course = this.courseList.length> 0?this.courseList[0]:'';
            this.courseId = this.courseList.length> 0?this.courseList[0]._id:'';
            this.subjectSuccess = this.courseList.length> 0?this.course.subject.length == this.course.subjectNumber:false
            this.fetchPercentSubjects();
          } else {
            this.alertFailError();
          }
          
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchPercentSubjects() {
      let obj = {
        courseId: this.courseId,
        userId: this.user.userId,
      };

      if (this.source) {
          this.source.cancel()
      }

      this.source = CancelToken.source()
      const cancelToken = this.source.token


      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`percent/subjects`, obj,{cancelToken})
        .then((res) => {
         
          if (res.data.success) {
            this.courseScoreList = res.data.obj;
          } else {
            this.courseScoreList = [];
          }
        })
        .catch((e) => {
          // this.alertCatchError(e);
          console.log("fetchPercentSubjects error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
  },
};
</script>

<style scoped></style>
